import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://taxi-arnouxandco.com';
const DEFAULT_DESC = "Taxi Arnoux & Co : réservez en ligne votre chauffeur privé en Tesla Model Y ou Van 8 places, 24h/24 et 7j/7. Transferts aéroports, gares et événements. Acompte de 10€ seulement.";

const PAGES = {
    '/': { title: 'Réservation en ligne | Taxi Arnoux & Co', desc: DEFAULT_DESC },
    '/reservation': { title: 'Réserver un taxi | Taxi Arnoux & Co', desc: "Réservez votre taxi Tesla Model Y ou Van 8 places en quelques clics avec Taxi Arnoux & Co. Choisissez votre trajet, date et heure. Acompte en ligne de 10€." },
    '/mon-compte': { title: 'Mon compte | Taxi Arnoux & Co', noindex: true },
    '/admin': { title: 'Administration | Taxi Arnoux & Co', noindex: true },
    '/payment/success': { title: 'Paiement confirmé | Taxi Arnoux & Co', noindex: true },
    '/payment/cancel': { title: 'Paiement annulé | Taxi Arnoux & Co', noindex: true },
};

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
    el.setAttribute('content', content);
};

export const Seo = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const path = PAGES[pathname] ? pathname : '/';
        const page = PAGES[path];
        const desc = page.desc || DEFAULT_DESC;
        const url = `${SITE}${path}`;
        document.title = page.title;
        setMeta('name', 'description', desc);
        setMeta('name', 'robots', page.noindex ? 'noindex, nofollow' : 'index, follow');
        setMeta('property', 'og:title', page.title);
        setMeta('property', 'og:description', desc);
        setMeta('property', 'og:url', url);
        setMeta('name', 'twitter:title', page.title);
        setMeta('name', 'twitter:description', desc);
        document.head.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
    }, [pathname]);

    return null;
};
